import { Avatar, Card, Col, Row, Select, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { FaCircle, FaClock, FaPlus } from 'react-icons/fa'
import './style.css'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6'
import AddBooking from '../AddBooking'
import Modal from '../../../../components/Modal'
import useJobApi from '../../../../config/hooks/api/booking/job/useJobApi'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import isoWeek from 'dayjs/plugin/isoWeek';
import { useDispatch } from 'react-redux'
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useLocation, useNavigate } from 'react-router-dom'
import { setSelectedBookingListStatus } from '../../../../store/common/bookingSlice'
import { bookingStatusDetails } from '../../../../config/utils/constants'
import { LoadingOutlined } from '@ant-design/icons'

dayjs.extend(utc);
dayjs.extend(localizedFormat);
dayjs.extend(isoWeek); // Extending Day.js to work with ISO weeks
dayjs.extend(customParseFormat);

// const wHours = [<FaClock className='text-primary bg-white text-lg ' />,
//     '10AM-12PM', '12PM-2PM', '2PM-4PM', '4PM-6PM', '6PM-8PM', '8PM-10PM', '10PM-12AM']

const wHours = [
    <FaClock className='text-primary bg-white text-lg' />,
    '10AM - 1PM',
    '1PM - 4PM',
    '4PM - 7PM',
    '7PM - 10PM',
    '10PM - 1AM',
    '1AM - 4AM',
    '4AM - 7AM',
    '7AM - 10AM'
];


const BookingCalendar = ({
    selectedWorkingHours = wHours,
    selectedFrequencyProp = 2
}) => {
    const { getJobsByDate } = useJobApi()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    const [offset, setOffset] = useState(0)
    const [currentDate, setCurrentDate] = useState(dayjs());
    // const [selectedBookingType, setSelectedBookingType] = useState('direct')
    const [selectedBookingTypeForCalendar, setSelectedBookingTypeForCalendar] = useState('')
    const [selectedProgress, setSelectedProgress] = useState(null)
    const [selectedFrequency, setSelectedFrequency] = useState(selectedFrequencyProp)
    const [modal, setModal] = useState(false)
    const [schedule, setSchedule] = useState(null)
    const [personalBookingSuccess, setPersonalBookingSuccess] = useState(false)
    const [loading, setLoading] = useState(false);
    const [isDataExist, setIsDataExist] = useState(false);

    console.log(schedule)

    console.log(isDataExist)

    const limit = 31
    const date = new Date()
    const frequency = [
        {
            id: 1,
            label: 'Daily',
        },
        {
            id: 2,
            label: 'Weekly',
        },
        {
            id: 3,
            label: 'Monthly'
        }
    ]

    const bookingType = [
        {
            value: 'direct',
            label: 'Direct'
        },
        {
            value: 'quote',
            label: 'Quote'
        },
    ]

    const progressType = [
        {
            value: '',
            label: 'All'
        },
        {
            value: 'pending',
            label: 'Pending'
        },
        {
            value: 'in-progress',
            label: 'In Progress'
        },
        {
            value: 'completed',
            label: 'Completed'
        },
        {
            value: 'responded',
            label: 'Responded'
        },
        {
            value: 'rejected',
            label: 'Rejected'
        },
        {
            value: 'admin assigned',
            label: 'Admin Assigned'
        },
    ]

    const workingHours = selectedWorkingHours


    // const handleBookingType = (e) => {
    //     setSelectedBookingType(e)
    // }

    const handleJobTypeSelection = (e) => {
        console.log(e,"burhan pass");
        
        if (e) {
            if (e === 'responded') {
                dispatch(setSelectedBookingListStatus('pending'))
                setSelectedProgress('pending')
            }
            else {
                dispatch(setSelectedBookingListStatus(e))
                setSelectedProgress(e)
            }
            if (location) {
                const jobPageUrl = '/booking/my-bookings'
                if (jobPageUrl !== location?.pathname) {
                    navigate('/booking/my-bookings')
                }
            }
        }
    }

    const openModal = () => {
        setModal(true)
    }

    const closeModal = () => {
        setModal(false)
    }

    const handleSelectedFrequency = (frequencyId) => {
        setSelectedFrequency(frequencyId)
        // setLimit(frequencyId == 1 ? 1 : frequencyId == 2 ? 7 : 30)
    }

    // Function to convert a time range in 'hAM/PM' format to minutes since midnight
    const convertToMinutes = (time) => {
        const hour = parseInt(time.slice(0, -2), 10); // Get the hour part
        const period = time.slice(-2); // Get AM/PM part
        let totalMinutes = hour * 60; // Convert hours to minutes

        if (period === 'PM' && hour !== 12) {
            totalMinutes += 12 * 60; // Convert PM hour to total minutes
        } else if (period === 'AM' && hour === 12) {
            totalMinutes -= 12 * 60; // Convert 12 AM to 0 minutes
        }

        return totalMinutes;
    };

    // Function to find the time range
    const findTimeRange = (time) => {
        if (!time) return

        // Convert the given time (e.g., '15:30') to minutes
        const [givenHour, givenMinute] = time.split(':').map(Number);
        const givenTimeInMinutes = givenHour * 60 + givenMinute;

        for (const range of workingHours.slice(1)) {
            const [start, end] = range.split('-');

            // Convert both start and end times to minutes
            const startTimeInMinutes = convertToMinutes(start);
            const endTimeInMinutes = convertToMinutes(end);

            // Handle cases where the end time might cross midnight
            const adjustedEndTime = endTimeInMinutes < startTimeInMinutes ? endTimeInMinutes + 24 * 60 : endTimeInMinutes;

            // Check if the given time falls within the range
            if (givenTimeInMinutes >= startTimeInMinutes && givenTimeInMinutes < adjustedEndTime) {
                return range; // Return the matching range
            }
        }

        return null; // If no range matches, return null
    };

    const calendarDateFormatConverter = (dateStr, time) => {
        if (!date) return null

        // Convert to Day.js object
        const dateObj = dayjs.utc(dateStr)

        // Format the object into the desired structure
        const formattedDate = {
            date: dateObj.date(), // 27
            day: dateObj.format('ddd'), // 'Thu' for Thursday
            month: dateObj.format('MMMM'), // 'September'
            year: dateObj.year(), // 2024
            time: dateObj.format('HH:mm') // '00:00'
        }

        return formattedDate
    }

    // Function to generate date range array
    const generateDateRange = (startDate, endDate) => {
        let start = dayjs.utc(startDate).startOf('day'); // Starting date set to midnight UTC
        const end = dayjs.utc(endDate).startOf('day');   // Ending date set to midnight UTC

        const dateArray = [];

        while (start.isBefore(end) || start.isSame(end)) {
            // Push the ISO string of each date
            dateArray.push(start.toISOString());
            // Increment the start date by 1 day
            start = start.add(1, 'day');
        }

        return dateArray;
    };

    const apiResponseToCalendarJsonFormatConverter = (startDate, endDate, data) => {
        if (!startDate || !endDate || !data) return null

        const schedule = []

        //loop to create calendar dates from each job booking date
        const calendarDates = generateDateRange(startDate, endDate);
        if (calendarDates.length) {
            for (let i = 0; i < calendarDates.length; i++) {
                const obj = {}

                const formattedBookingDate = calendarDateFormatConverter(calendarDates[i])
                if (formattedBookingDate) {
                    const matchingDateBookings = data.filter(e =>
                        calendarDateFormatConverter(e.bookingDate).date == formattedBookingDate.date
                    )
                    obj.id = i
                    obj.bookingDate = calendarDates[i]
                    obj.date = `${formattedBookingDate?.day} ${formattedBookingDate?.date}`
                    obj.schedule = {}

                    //loop to create hourly schedule format
                    const dailyWorkingHours = workingHours.slice(1)
                    for (let i = 0; i < dailyWorkingHours.length; i++) {
                        obj.schedule[dailyWorkingHours[i]] = []
                    }

                    if (matchingDateBookings.length) {
                        //loop to add matching date bookings to their scheduled hours
                        for (let i = 0; i < matchingDateBookings.length; i++) {
                            obj.bookingDate = matchingDateBookings[i].bookingDate

                            const hourlyScheduledJob = {}
                            const bookingTimeRange = findTimeRange(matchingDateBookings[i].time)

                            if (bookingTimeRange) {
                                hourlyScheduledJob.bookingId = matchingDateBookings[i].id
                                hourlyScheduledJob.serviceUser = matchingDateBookings[i].serviceUser
                                hourlyScheduledJob.status = matchingDateBookings[i].status
                                hourlyScheduledJob.bkType = matchingDateBookings[i].quote ? 'quote' : 'direct'
                                hourlyScheduledJob.vehicleRegistrationNo = matchingDateBookings[i].vehicleRegistrationNo
                                hourlyScheduledJob.time = matchingDateBookings[i].time

                                obj.schedule[bookingTimeRange].push(hourlyScheduledJob)
                            }
                        }
                    }
                }
                schedule.push(obj)
            }
            return schedule
        }
    }

    // Get start and end dates based on the current date
    const getDateRangeByFrequency = () => {
        const period = selectedFrequency == 1 ? 'day' : selectedFrequency == 2 ? 'week' : 'month'
        const startDate = currentDate.startOf(period).format('YYYY-MM-DD')
        const endDate = currentDate.endOf(period).format('YYYY-MM-DD')
        return { startDate, endDate }
    };


    // Function to get date range for the next period
    const handleNext = () => {
        if (selectedFrequency === 1) {
            setCurrentDate(currentDate.add(1, 'day'));
        } else if (selectedFrequency === 2) {
            setCurrentDate(currentDate.add(1, 'week'));
        } else if (selectedFrequency === 3) {
            setCurrentDate(currentDate.add(1, 'month'));
        }
    };

    // Function to get date range for the previous period
    const handlePrevious = () => {
        if (selectedFrequency === 1) {
            setCurrentDate(currentDate.subtract(1, 'day'));
        } else if (selectedFrequency === 2) {
            setCurrentDate(currentDate.subtract(1, 'week'));
        } else if (selectedFrequency === 3) {
            setCurrentDate(currentDate.subtract(1, 'month'));
        }
    };

    const getJobsBySchedule = async () => {
        try {
            setLoading(true)

            // const dates = getStartEndDates()
            const dates = getDateRangeByFrequency()

            const response = await getJobsByDate(
                limit,
                offset,
                // selectedBookingType,
                selectedBookingTypeForCalendar === 'in-progress' ? 'inprogress' : selectedBookingTypeForCalendar,
                dates?.startDate,
                dates?.endDate
            )
            if (response) {
                const formattedResponse = apiResponseToCalendarJsonFormatConverter(
                    dates?.startDate,
                    dates?.endDate,
                    Array.isArray(response?.data?.jobs) ? response?.data?.jobs : [response?.data?.jobs]
                )
                console.log(response)
                setSchedule(formattedResponse)
                setLoading(false)
                if (response?.data?.jobs?.length == 0) {
                    setIsDataExist(false);
                }
                else {
                    setIsDataExist(true);
                }
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    const handleAddBookingSuccess = () => {
        closeModal()
        setPersonalBookingSuccess(true)
    }

    const getBookingColorByStatus = (statusId) => {
        if (!statusId) return null

        const bookingStatusLabel = bookingStatusDetails.filter(e => e.status === statusId)[0]
        return `bg-${bookingStatusLabel.label.toLowerCase()}`
    }


    useEffect(() => {
        if (
            selectedFrequency ||
            selectedBookingTypeForCalendar ||
            currentDate ||
            // selectedBookingType || 
            personalBookingSuccess
        ) {
            getJobsBySchedule()
        }
    }, [
        selectedFrequency,
        selectedBookingTypeForCalendar,
        currentDate,
        // selectedBookingType, 
        personalBookingSuccess
    ])



    return (
        <Card
            bordered={false}
            className='rounded-md'
        >
            <Row>
                {/* { selectedJobStatusChange ? ( */}
                <React.Fragment>
                    <Col span={24} className='mb-4'>
                        <div className='flex sm:flex-row flex-col justify-between items-center mb-4'>
                            <div className='flex sm:w-fit w-full cursor-pointer mb-2'>
                                <h5 className='heading-5 mb-0 font-bold'>
                                    {currentDate.format('MMMM')},
                                    {' '}
                                    {currentDate.format('YYYY')}
                                </h5>
                                <FaChevronLeft
                                    className={`sm:ml-4 ml-0 p-1 text-2xl rounded-sm 
                                            ${offset != 0 ? 'bg-primary text-white' : 'border text-black'}`
                                    }
                                    onClick={handlePrevious}
                                />
                                <FaChevronRight
                                    className={`ml-2 p-1 text-2xl rounded-sm 
                                            ${offset == 0 ? 'bg-primary text-white' : 'border text-black'}`
                                    }
                                    onClick={handleNext}
                                />
                            </div>
                            <div className='flex sm:flex-row flex-col  sm:w-fit w-full'>
                                <div className='flex sm:flex-row flex-col'>
                                    {/* <Select
                                            defaultValue="Direct"
                                            onChange={handleBookingType}
                                            options={bookingType}
                                            className='mb-2'
                                        /> */}
                                    <Select
                                        defaultValue="All Booking"
                                        onChange={handleJobTypeSelection}
                                        options={progressType}
                                        className='sm:ml-2 mb-2'
                                    />
                                </div>
                                <div className='bg-primary flex items-center p-2 sm:w-fit w-full sm:ml-2 sm:rounded-sm rounded-md cursor-pointer'>
                                    <FaPlus className='text-white' />
                                    <small onClick={openModal} className='ml-2 text-white font-semibold'>Add New Booking</small>
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col span={24}>
                        <div className='flex sm:flex-row flex-col items-center mb-6'>
                            <div className='flex sm:mb-0 mb-4 sm:w-fit w-full'>
                                {frequency && frequency.length && frequency.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`
                                                ${selectedFrequency == item.id ?
                                                'bg-black text-white' :
                                                'bg-slate-100 text-black'
                                            }
                                                py-3 px-4 text-xs rounded-sm sm:w-fit w-full cursor-pointer
                                            `}
                                        onClick={() => handleSelectedFrequency(item.id)}
                                    >
                                        {item?.label}
                                    </div>
                                ))}
                            </div>
                            <div className='flex sm:ml-6 ml-0 flex-wrap w-full'>
                                {
                                    progressType &&
                                    progressType.length &&
                                    progressType
                                        .filter(e => e.label == 'All' || e.value === 'in-progress' || e.value === 'completed')
                                        .map((item, index) => (
                                            <div
                                                key={'progress' + index}
                                                className={`flex items-center sm:mr-6 mr-4 cursor-pointer`}
                                                onClick={() => setSelectedBookingTypeForCalendar(item?.value)}
                                            >
                                                {/* <span className={`
                                                    rounded-full w-[20px] h-[20px] 
                                                    ${item?.value == 'in-progress' ? 'bg-[#F77F00]' : 'bg-[#3879F0]'} rounded-full
                                                    `}
                                                >
                                                </span> */}
                                                <FaCircle size={20} className={`text-${item?.value}`} />
                                                <small
                                                    className={`
                                                        text-xs ml-1 
                                                        ${selectedBookingTypeForCalendar === item?.value && 'font-bold'}
                                                    `}
                                                >
                                                    {item?.label}
                                                </small>
                                            </div>
                                        ))
                                }
                            </div>
                        </div>
                    </Col>
                </React.Fragment>
                {/* ) : '' } */}

                {!isDataExist && <p className='my-2 text-red-400'>No upcoming booking</p>}

                {/* calendar */}
                {!loading ? (
                    <Row className='w-full'>
                        {/* working hours */}
                        <Col sm={3} xs={4} className='pb-0'>
                            {workingHours.map((hour, index) => (
                                <Col
                                    key={'wh' + index}
                                    span={24}
                                    className={`flex justify-center bg-slate-100 
                                    ${index == 0 ? 'h-[50px] pt-5 rounded-tl-lg' :
                                            'items-center h-[100px] py-8 px-4'
                                        }`
                                    }
                                >
                                    <div className={`text-xs`}>{hour}</div>
                                </Col>
                            ))}
                        </Col>

                        <Col sm={21} xs={20} id='schedule'>
                            <Row className="scrollable-row overflow-x-auto ">
                                {/* schedule */}
                                {schedule && schedule.length && schedule.slice(offset, limit + offset).map((day, index) => (
                                    <Col
                                        key={day?.id}
                                        // span={4}
                                        sm={3}
                                        xs={12}
                                        className={`
                                        flex justify-center 
                                        ${index != limit + offset - 1 && 'border border-dashed'}`
                                        }
                                    >
                                        <div className='column-item flex-col w-full'>
                                            <div className={`text-xs pt-4 h-[50px] bg-slate-100 text-center
                                            ${index == limit + offset - 1 && 'rounded-tr-lg'}`}> {day.date}</div>
                                            <div className='w-full'>
                                                {Object.keys(day.schedule).map((hour, index) => (
                                                    <Col
                                                        key={'schedule' + index}
                                                        span={24}
                                                        className={`hour flex-col justify-center items-center border border-dashed h-[100px]
                                                    overflow-y-auto `}
                                                    >
                                                        {day.schedule[hour] && day.schedule[hour].length ? day.schedule[hour].map((event, index) => (
                                                            <div className={`cursor-pointer overflow-x-auto p-2 flex items-center rounded-sm border-b border-white
                                                            ${getBookingColorByStatus(event?.status)}
                                                            `}
                                                                key={'booking' + index}
                                                                onClick={() => navigate(
                                                                    event?.serviceUser ?
                                                                        `/myjobs/${event?.bookingId}` :
                                                                        null
                                                                )}
                                                            >
                                                                <div className='w-[25px] mb-2'>
                                                                    <Avatar
                                                                        src={event?.serviceUser?.imageThumbUrl}
                                                                        size='small'
                                                                        className='border border-white'
                                                                    />
                                                                </div>
                                                                <div className='flex flex-col ml-2'>
                                                                    <small className='inline-block text-xs text-white mb-1'>{event?.serviceUser?.fullName}</small>
                                                                    <small className='inline-block text-[7px] mb-1 text-white'>{event?.serviceUser?.type.toLowerCase()}</small>
                                                                    <small className='inline-block text-[7px] mb-1 text-white'>{event?.time}</small>
                                                                </div>
                                                            </div>
                                                        )) : null}
                                                        {/* ${day.schedule[hour].length && day.schedule[hour].status == 1 ? 
                                                        'bg-[#3879F0]' : day.schedule[hour].status == 4 ? 'bg-[#F77F00]' : '' }  */}
                                                    </Col>
                                                ))}
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                ) : (
                    <div className='w-full flex justify-center'>
                        <Spin indicator={<LoadingOutlined className='text-[#333]' spin />} size="large" />
                    </div>
                )}
            </Row>
            <Modal.Basic open={modal} onCancel={closeModal} width={500} maskClosable={false}>
                <AddBooking onSuccess={handleAddBookingSuccess} />
            </Modal.Basic>
        </Card>
    )
}

export default BookingCalendar